<template>
  <div class="store__getting-started">
    <h1 class="headline" v-if="customerTypeLabel">Tell us what kind of water your {{ customerTypeLabel }} needs</h1>
    <h1 class="headline" v-else>Tell us what kind of water you need</h1>

    <div v-html="content"></div>

    <div class="d-flex justify-content-center" v-if="isLoading">
      <div class="spinner-border" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>

    <div class="products">
      <router-link to="/gallon-water" class="products__product" v-if="hasGallonWaterProducts">
        <h2 class="product__name">Gallon Water<br> Delivery & Coolers</h2>
        <img :src="pluginUrl + '/assets/img/gallon-water-delivery.png'" alt="" class="product__img">
        <span class="btn btn-store">Get Started</span>
      </router-link>

      <router-link to="/bottle-free-cooler" class="products__product" v-if="hasBottleFreeCoolers">
        <h2 class="product__name">Bottle-Free<sup>&reg</sup><br> Coolers</h2>
        <img :src="pluginUrl + '/assets/img/bottle-free-coolers.png'" alt="" class="product__img">
        <span class="btn btn-store">Shop Bottle-less Solutions</span>
      </router-link>

      <router-link to="/products" class="products__product" v-if="hasDefaultProducts">
        <h2 class="product__name">Small Pack<br> Bottled Water</h2>
        <img :src="pluginUrl + '/assets/img/small-pack-bottled-water.png'" alt="" class="product__img pb-2">
        <span class="btn btn-store">Shop Products</span>
      </router-link>
    </div> <!-- .products -->

    <!-- <router-link to="/products" class="btn btn-store">Shop All Offerings</router-link> -->

    <!--
    <product-suggestions 
      headline="Office Coffee Made Easy with Culligan!" 
      categorySlug="coffee"
    ></product-suggestions>
    -->

  </div> <!-- .store__getting-started -->
</template>

<script>
import store from '../store.js'
// import ProductSuggestions from './ProductSuggestions.vue'

export default {
  computed: {
    isLoading() {
      return ! this.hasGallonWaterProducts &&
             ! this.hasBottleFreeCoolers &&
             ! this.hasDefaultProducts
    },
    content() {
      if (store.state.pages && store.state.pages.home) {
        return store.state.pages.home.page.content
      }
    },
    customerTypeLabel() {
      return store.getters.customerTypeLabel
    },
    pluginUrl() {
      return store.state.pluginUrl
    },
    hasGallonWaterProducts() {
      return store.getters.getDefaultGallonWater.name != ''
    },
    hasBottleFreeCoolers() {
      return store.getters.getBottleFreeCoolers.length > 0
    },
    hasDefaultProducts() {
      return store.getters.getDefaultProducts.length > 0
    },
  },
  // components: {
  //   ProductSuggestions,
  // }
}
</script>
